const RICH_DESCRIPTION_ITEM_TYPES = [
    'artifact',
    'shard_artifact',
    'scroll',
    'entry',
    'scroll_artifact',
    'scroll_entry'
];
const TAG_PATTERN = /<\/?[a-z][a-z0-9]*\b[^>]*>/iu;
const BLOCK_END_PATTERN = /<\/(?:p|li|h[1-6]|div|tr|ul|ol|table)>|<br\s*\/?>/giu;

export const hasRichDescription = (itemType?: string | null): boolean => RICH_DESCRIPTION_ITEM_TYPES.includes(itemType || '');

export const descriptionText = (text?: string | null): string => {
    if (!text) {
        return '';
    }

    if (!TAG_PATTERN.test(text)) {
        return text;
    }

    const doc = new DOMParser().parseFromString(text.replace(BLOCK_END_PATTERN, '$& '), 'text/html');

    return (doc.body.textContent || '').replace(/\s+/gu, ' ').trim();
};
